import Analytics from '@hh.ru/analytics-js';
import { useBreakpoint } from '@hh.ru/magritte-ui';
import { usePush } from '@hh.ru/redux-spa-middleware';
import urlParser from 'bloko/common/urlParser';

import { useSelector } from 'src/hooks/useSelector';

import ItemsOnPage from 'src/components/Search/Resume/Settings/ItemsOnPage';
import SearchOrder from 'src/components/Search/Resume/Settings/Order';
import SearchPeriod from 'src/components/Search/Resume/Settings/Period';
import ResumeView from 'src/components/Search/Resume/Settings/ResumeView';

import styles from './styles.less';

const SETTINGS_SAVE_SEARCH_SESSION_ID = ['items_on_page'];

const Settings = () => {
    const criteria = useSelector((state) => state.resumeSearchResult.criteria);
    const queries = useSelector((state) => state.resumeSearchResult.queries);
    const pathname = useSelector((state) => state.router.location.pathname);
    const showSearchPreference = useSelector((state) => state.searchPreference.isShown);
    const searchSessionId = useSelector((state) => state.searchSessionId);
    const defaultHhtmSource = useSelector((state) => state.analyticsParams.hhtmSource);
    const { isMobile } = useBreakpoint();
    const push = usePush();

    const queryMap = {
        search_period: queries.searchPeriodBase,
        order_by: queries.orderByBase,
        items_on_page: queries.itemsOnPageBase,
    };

    const handleChange = (name, value) => {
        const query = queryMap[name];
        const url = urlParser(pathname);
        url.search = query;
        url.params = { ...url.params, [name]: [value] };
        if (searchSessionId && SETTINGS_SAVE_SEARCH_SESSION_ID.includes(name)) {
            url.params.searchSessionId = searchSessionId;
        }
        push(url.href);
    };

    const {
        search_period: searchPeriod,
        order_by: orderBy,
        items_on_page: itemsOnPage,
        date_from: dateFrom,
        date_to: dateTo,
    } = criteria;

    const genericSearchPeriod = dateFrom && dateTo ? 'customInterval' : searchPeriod;

    return (
        <div className={styles.settings}>
            <div className={styles.group}>
                <SearchPeriod
                    onChange={(value) => {
                        handleChange('search_period', value);

                        const buttonName = `resume_search_filter_${isMobile ? 'touch' : 'apply'}`;
                        const hhtmSource = isMobile ? `resume_search_filter` : defaultHhtmSource;
                        Analytics.sendHHEventButtonClick(buttonName, {
                            type: 'SEARCH_PERIOD',
                            oldValue: genericSearchPeriod,
                            newValue: value,
                            hhtmSource,
                        });
                    }}
                    value={genericSearchPeriod}
                />
                <SearchOrder
                    onChange={(value) => {
                        handleChange('order_by', value);
                    }}
                    value={orderBy}
                />
                <ItemsOnPage
                    onChange={(value) => {
                        handleChange('items_on_page', value);
                    }}
                    value={itemsOnPage}
                />
            </div>
            {!showSearchPreference && <ResumeView />}
        </div>
    );
};

export default Settings;
